import { render, staticRenderFns } from "./HomeInlet.vue?vue&type=template&id=067aaf96&scoped=true"
import script from "./HomeInlet.vue?vue&type=script&lang=js"
export * from "./HomeInlet.vue?vue&type=script&lang=js"
import style0 from "./HomeInlet.vue?vue&type=style&index=0&id=067aaf96&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067aaf96",
  null
  
)

export default component.exports